export const SERVICES = {
    identity: 'Sravni.Identity.Service',
    identityUserImport: 'identity.user.import',
    profile: 'profile.form.rw',
    scoring: 'scoring.task.rw',
    selectionApi: 'creditselection.api',
};

export default process.env as NodeJS.ProcessEnv;
